<template>
    <v-container class="reset-password-init p-0" fluid>
        <vue-headful :title="$t('reset_password.title') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame
            :label="$t('reset_password.title')"
            :is-snap-content="true">
            <div class="form-div">
                <v-form>
                    <v-row>
                        <v-col>
                            <v-row class="form-title title-font">{{$t('reset_password.email')}}</v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                                :label="$t('reset_password.email')"
                                                :placeholder="$t('reset_password.email')"
                                                v-model="email"
                                                autocomplete="username"
                                                @keyup.enter="resetPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-left">
                                    <v-btn dark rounded x-large
                                     @click="resetPassword"
                                    class="function-button"
                                        color="rgb(142, 118, 91)">
                                        {{$t('reset_password.title')}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
        </HkiaraceBannerFrame>

        <b-modal id="resetInitSuccessModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <b-container class="reset-success-container">
                <b-row>
                    <b-col class="reset-success-icon">
                        <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="reset-success-title">
                        {{$t('reset_password_init.modal_title')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{$t('reset_password_init.modal_content')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="reset-success-close-btn"
                                  @click="$bvModal.hide('resetInitSuccessModal')">{{$t('close')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </v-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";

    library.add(faEnvelope);

    export default {
        name: 'ResetPassword',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                email: '',
                pageWidth: 1
            };
        },
        mounted() {
            this.pageWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.pageWidth = window.innerWidth;
                });
            })
        },
        methods: {
            resetPassword() {
                if (!this.email) {
                    return
                }
                this.$callAPI('hkiarace/reset_password_init/', {email: this.email}, function (response) {
                    this.$bvModal.show("resetInitSuccessModal");
                });
            },
        }
    }
</script>

<style lang="less">
    .reset-password-init {
        .form-div {
            padding: 16px 10% 24px 10%;
            background-color: white;

            .form-title {
                font-size: 1.5rem;
                padding-top: 32px;
                padding-bottom: 16px;
                padding-left: 12px;
            }

            .v-input {
                border-radius: 0;
            }
        }
    }

    #resetInitSuccessModal {
        text-align: center;

        .reset-success-container {
            padding-top: 48px;
            font-size: 1.5rem;

            .row {
                margin-bottom: 2rem;
            }

            .reset-success-icon {
                font-size: 5rem;
            }

            .reset-success-title {
                font-weight: bold;
                font-size: 2.5rem;
            }

            .reset-success-close-btn {
                background-color: black;
                border-radius: 0;
                width: 100%;
                font-size: 1.5rem;
            }
        }
    }

    @media only screen and (min-width: 600px) {
        .form-div {
            top: calc(20% - 5rem) !important;
        }
    }

    @media only screen and (min-width: 820px) {
        .form-div {
            top: calc(20% - 10rem) !important;;
        }
    }

    @media only screen and (min-width: 960px) {
        .form-div {
            top: calc(20%) !important;;
        }
    }

    @media only screen and (min-width: 1248px) {
        .form-div {
            top: calc(20% + 5rem) !important;
        }
    }
</style>
